export default __webpack_public_path__ + "static/media/view-all-arrow.83f3bde6.svg";